<mat-accordion>
    <!-- Sezione dati del contraente -->
    <ng-container *ngIf="contractorRegistryForm">
        <div class="mt-4">
            <app-registry-form
                [panelTitle]="'Dati del contraente del rapporto continuativo'"
                [registryForm]="contractorRegistryForm"
                [residenceForm]="contractorResidenceForm"
                [addressForm]="contractorAddressForm"
                [identificationDocumentForm]="contractorIdentificationDocumentForm"
                [consentForm]="consentsForm"
                [properVerificationForm]="properVerificationForm"
                [businessForm]="contractorBusinessForm"
                [operationForm]="operationForm"
                [operatorForm]="operatorForm"
                [saeList]="saeList"
                [taeList]="taeList"
                [atecoList]="atecoList"
                [activityTypes]="activityTypes"
                [countriesList]="countriesList"
                [provincesList]="provincesList"
                [placesList]="placesList"
                [documentTypeList]="documentTypeList"
                [beneficiariesClassification]="beneficiariesClassification"
                [businessTypes]="businessTypes"
                [documentReleaseAuthorityList]="documentReleaseAuthorityList"
                [agreementPurposeList]="agreementPurposeList"
                [customerBehaviourList]="customerBehaviourList"
                [fundsOriginList]="fundsOriginList"
                [incomeLevelsList]="incomeLevelsList"
                [executionModeList]="executionModeList"
                [operationExecutionModeList]="operationExecutionModeList"
                [paymentMethodsList]="paymentMethodsList"
                [presenceInExternalList]="presenceInExternalList"
                [professionsList]="professionsList"
                [incomeBracketsList]="incomeBracketsList"
                [chargeTypes]="chargeTypes"
                [holderBeneficiaryRelationshipList]="holderBeneficiaryRelationshipList"
            ></app-registry-form>
        </div>
        <div class="mt-4">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>Dati apertura polizza / operazione</mat-panel-title>
                </mat-expansion-panel-header>
                <app-basic-form [form]="operationForm" [keys]="operationFormKeys"></app-basic-form>
            </mat-expansion-panel>
        </div>
        <div class="mt-4" *ngIf="showInsuredSection">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>Censimento Assicurato</mat-panel-title>
                </mat-expansion-panel-header>
                <app-basic-form [form]="insuredForm" [keys]="insuredFormKeys"></app-basic-form>
            </mat-expansion-panel>
        </div>
        <div class="mt-4" *ngIf="showBeneficiarySection">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>Designazione beneficiario</mat-panel-title>
                </mat-expansion-panel-header>
                <app-basic-form [form]="beneficiaryForm" [keys]="filteredBeneficiaryFormKeys"></app-basic-form>
            </mat-expansion-panel>
        </div>
        <div class="mt-4">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>Dati a cura dell'operatore</mat-panel-title>
                </mat-expansion-panel-header>
                <app-basic-form [form]="operatorForm" [keys]="operatorFormKeys"></app-basic-form>
            </mat-expansion-panel>
        </div>
    </ng-container>
    <!-- Sezione dati del tutore/rappresentante legale -->
    <ng-container *ngIf="legalGuardianRegistryForm">
        <div class="mt-4">
            <app-registry-form
                [panelTitle]="'Dati del rappresentante legale/procuratore'"
                [isEsecutoreConto]="true"
                [registryForm]="legalGuardianRegistryForm"
                [residenceForm]="legalGuardianResidenceForm"
                [addressForm]="legalGuardianAddressForm"
                [identificationDocumentForm]="legalGuardianIdentificationDocumentForm"
                [properVerificationForm]="legalGuardianProperVerificationForm"
                [countriesList]="countriesList"
                [provincesList]="provincesList"
                [placesList]="placesList"
                [documentTypeList]="documentTypeList"
                [documentReleaseAuthorityList]="documentReleaseAuthorityList"
                [agreementPurposeList]="agreementPurposeList"
                [customerBehaviourList]="customerBehaviourList"
                [fundsOriginList]="fundsOriginList"
                [relazioneContraenteEsecutore]="relazioneContraenteEsecutore"
                [tipoDelega]="tipoDelega"
                [incomeLevelsList]="incomeLevelsList"
                [executionModeList]="executionModeList"
                [operationExecutionModeList]="operationExecutionModeList"
                [presenceInExternalList]="presenceInExternalList"
                [professionsList]="professionsList"
                [isLegalGuardian]="true"
            ></app-registry-form>
        </div>
    </ng-container>
    <!-- Sezione titolari effettivi -->
    <ng-container *ngIf="showEffectiveOwnersSection">
        <div class="mt-4">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>Dati dei titolari effettivi</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngFor="let effectiveOwner of effectiveOwnersList; let i = index; trackBy: trackByIndex">
                    <div class="mt-3">
                        <app-registry-form
                            [panelTitle]="getEffectiveOwnerPanleTitle(i)"
                            [registryForm]="effectiveOwner.registryForm"
                            [residenceForm]="effectiveOwner.residenceForm"
                            [identificationDocumentForm]="effectiveOwner.identificationDocumentForm"
                            [properVerificationForm]="effectiveOwner.properVerificationForm"
                            [customerBehaviourList]="customerBehaviourList"
                            [countriesList]="countriesList"
                            [provincesList]="provincesList"
                            [placesList]="placesList"
                            [documentTypeList]="documentTypeList"
                            [presenceInExternalList]="presenceInExternalList"
                            [documentReleaseAuthorityList]="documentReleaseAuthorityList"
                            [buttonsList]="effectiveOwnersButtonList"
                            [professionsList]="professionsList"
                            [isEffectiveOwner]="true"
                            [isReadOnly]="isReadOnly"
                            (actionRequested)="onActionRequested($event, i)"
                        ></app-registry-form>
                    </div>
                </ng-container>
                <div class="mt-3 mb-3" *ngIf="!isReadOnly">
                    <button 
                        mat-raised-button 
                        color="primary" 
                        [disabled]="effectiveOwnersList.length >= 4"
                        (click)="addNewEffectiveOwner()"
                    >Aggiungi titolare effettivo</button>
                </div>
            </mat-expansion-panel>
        </div>
    </ng-container>
</mat-accordion>
